<template>
  <footer>
    <div class='top cf w_1200'>
      <router-link to='/' class='logo img_box fl'><img src='./../assets/icons/logo_tab@2x.png' alt=''></router-link>
      <ul class='fr fz_0'>
        <li>
          <h3>{{ $t('home.links.product.title') }}</h3>
          <p><router-link to='/goods'>{{ $t('home.links.product.list[0]') }}</router-link></p>
          <p><router-link to='/talkingPen'>{{ $t('home.links.product.list[1]') }}</router-link></p>
          <p><router-link to='/listenEnglish'>{{ $t('home.links.product.list[2]') }}</router-link></p>
          <p><router-link to='/highFive'>{{ $t('home.links.product.list[3]') }}</router-link></p>
        </li>
        <li>
          <h3>{{ $t('home.links.other.title') }}</h3>
          <p><a target='_blank' href='http://www.xiaobien.com'>{{ $t('home.links.other.list[0]') }}</a></p>
          <p><a target='_blank' href='https://www.baobaobooks.com'>{{ $t('home.links.other.list[1]') }}</a></p>
          <p><router-link to='/authorize-search'>{{ $t('home.links.other.list[2]') }}</router-link></p>
        </li>
        <li>
          <h3>{{ $t('home.links.company.title') }}</h3>
          <p><router-link to='/company-newsList'>{{ $t('home.links.company.list[0]') }}</router-link></p>
          <p><router-link to='/about'>{{ $t('home.links.company.list[1]') }}</router-link></p>
          <p><router-link to='/recruitList'>{{ $t('home.links.company.list[2]') }}</router-link></p>
          <p><a href='javascript:void(0)' @click='showPublicNo'>{{ $t('home.links.company.list[3]') }}</a></p>
        </li>
        <li>
          <h3>{{ $t('home.links.contact.title') }}</h3>
          <p><a href='mailto:amy@hbtown.com'>{{ $t('home.links.contact.list[0]') }}</a></p>
          <p><a>{{ $t('home.links.contact.list[1]') }}</a></p>
        </li>
      </ul>
    </div>
    <div class='bottom'>
      {{ $t('home.bottom.right') }}：
      <a class='grey' href='https://beian.miit.gov.cn/#/Integrated/recordQuery' target='_blank'>{{ $t('home.bottom.number') }}</a>
    </div>

    <!-- 二维码 -->
    <contact-q-r-code :show='showDialog' @close='closePublicNo'></contact-q-r-code>
  </footer>
</template>
<script>
import ContactQRCode from '@/components/ContactQRCode'
import { listHandler } from '@/utils/variable'

export default {
  name: 'Footer',
  components: {
    ContactQRCode,
  },
  data () {
    return {
      showDialog: false,
    }
  },
  computed: {
    list () {
      let list = [
        {
          urlList: ['/goods', '/talkingPen', '/listenEnglish', '/highFive'],
        },
        {
          urlList: ['http://www.xiaobien.com', 'https://www.baobaobooks.com', '/authorize-search'],
        },
        {
          urlList: ['/goods', '/talkingPen', '/listenEnglish', '/highFive'],
        },
        {
          urlList: ['/goods', '/talkingPen', '/listenEnglish', '/highFive'],
        },
      ]
      // 结合语言版本进行初始化数据
      return listHandler.call(this, list, 'home.links')
    },
  },
  methods: {
    showPublicNo () {
      document.body.className = 'fixed'
      this.showDialog = true
    },
    closePublicNo () {
      document.body.className = ''
      this.showDialog = false
    },
  },
}
</script>
